<template>
  <v-card v-if="chartData">
    <Pie id="all-treinos-pie" :options="chartOptions" :data="chartData" />
  </v-card>
</template>

<script>
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js/auto'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  name: 'AllTreinosPieChart',
  components: { Pie },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: 'Treinos por Esporte'
          },
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            enabled: true,
          }
        }
      }
    }
  }
}
</script>
